import styled from 'styled-components'
import variables from '../../styles/variables'
import { TextWrapper } from '../../styles/base'
import { headerStyles } from '../../styles/global'
import { Heading } from '..'
import plusPattern from '../../../assets/plus-pattern.svg'
import { ReactComponent as RealTimeLearning } from '../../../assets/winner.svg'
import { ReactComponent as PredictAnyVariable } from '../../../assets/real-time-learning-black.svg'
import { ReactComponent as HiddenMagic } from '../../../assets/api-black.svg'

export const Container = styled.div`
`

export const IndustrySolutionsContainer = styled.div`
  width: 100%;
  background-color: ${variables.colors.white};
`

export const PlusPatternContainer = styled.div`
  width: 100%;
  background-image: url(${plusPattern});
`

export const PerformanceContainer = styled.div`
  width: 100%;
  background-color: ${variables.colors.lightGrey};
  padding: 60px 0;
  
  @media (max-width: 768px) {
    padding: 40px 0;
  }
`

export const LogoContainer = styled.div`
  width: 100%;
  background-color: ${variables.colors.white};
`

export const SectionContainer = styled(TextWrapper)`
  padding: 20px 0 0 0;
  @media ${variables.media.sm} {
    padding: 60px 40px;
  }
  @media ${variables.media.md} {
    padding: 0 30px;
  }
`

export const QuoteContainer = styled(SectionContainer)`
  @media ${variables.media.md} {
    padding: 60px 30px;
  }
`

export const SectionHeader = styled(Heading)`
  ${headerStyles.headerXSmall};
  color: ${variables.colors.charcoal};
  margin-left: 20px;
  margin-bottom: 0;
  word-spacing: normal;

  @media ${variables.media.sm} {
    margin-left: 0;
  }
`

export const Centerer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
`

export const IconWrapper = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 7px;
  display: flex;
  justify-content: center;
  align-items: center;

  ${props => props.color === 'green' && `
    background: rgba(93, 80, 255, 0.15);
  `}

  ${props => props.color === 'pink' && `
    background: rgba(18, 181, 173, 0.15);
  `}

  ${props => props.color === 'blue' && `
    background: rgba(55, 51, 107, 0.15);
  `}
`

export const RealTimeLearningIcon = styled(RealTimeLearning)`
  width: 42px;
  height: 80px;
  
  * {
    fill: white !important;
  }
`

export const PredictAnyVariableIcon = styled(PredictAnyVariable)`
  width: 80px;
  height: 80px;
  
  * {
    fill: white !important;
  }
`

export const HiddenMagicIcon = styled(HiddenMagic)`
  width: 80px;
  height: 80px;
  
  * {
    fill: white !important;
  }
`

export const TechnologyCtaContainer = styled.div`
  background: linear-gradient(90deg, ${variables.colors.brandPrimary} 0%, ${variables.colors.sunsetPurple} 50%, ${variables.colors.coreViolet} 100%);
  margin: 4rem 0;
  padding: 3rem 2rem;
  text-align: center;
  color: ${variables.colors.white};
`

export const TechnologyCtaContent = styled.div`
  max-width: 700px;
  margin: 0 auto;
`

export const TechnologyCtaHeader = styled.h2`
  font-size: 2.2rem;
  font-weight: 700;
  color: ${variables.colors.white};
  margin-bottom: 1.5rem;
  font-family: ${variables.fonts.header};
  word-spacing: normal;
  
  @media ${variables.media.sm} {
    font-size: 1.8rem;
  }
`

export const TechnologyCtaText = styled.p`
  font-size: 1.2rem;
  line-height: 1.6;
  color: ${variables.colors.greyLightest};
  margin-bottom: 2rem;
  
  @media ${variables.media.sm} {
    font-size: 1.1rem;
  }
`

export const TechnologyCtaButton = styled.div`
  display: flex;
  justify-content: center;
`

export const IntegrationPlatfromContainer = styled.div`
  width: 100%;
  background: ${variables.colors.deepIndigo};
  display: flex;
  justify-content: center;
`
